export enum AllianzPlansTypes {
  premium = 'premium',
  travel = 'travel',
  noPlan = 'no-plan',
}
